/**
 * Packed `ITrackingRenderState.latLngs` layout: [lat₀, lng₀, lat₁, lng₁, …].
 * One GPS point occupies two consecutive floats.
 */
export const TRACKING_RENDER_COORDS_PER_POINT = 2;

/** Latitude slot within one packed [lat, lng] pair. */
export const TRACKING_RENDER_PACKED_LAT_OFFSET = 0;

/** Longitude slot within one packed [lat, lng] pair. */
export const TRACKING_RENDER_PACKED_LNG_OFFSET = 1;

/** Below this zoom, tracking trail lines render without direction arrows (SVG textpath cost). */
export const TRACKING_ARROW_MIN_ZOOM = 13;

/**
 * Below this zoom, intermediate trail dots are not drawn at all. Decimation alone still leaves ~50 dots per
 * ride at metro zoom (step 20 of a 1000-point trail) — thousands across a full live map — and at that scale
 * they read as a dotted line rather than as hoverable GPS samples, which is their only purpose.
 */
export const TRACKING_POINT_MIN_ZOOM = 12;

/** Throttle shared trail-point tooltip updates on map mousemove (ms). */
export const DEFAULT_TRACKING_TRAIL_POINTS_HOVER_THROTTLE_MS = 50;

/** Map zoom → render every Nth intermediate tracking point (car marker always shown). */
export const TRACKING_POINT_DECIMATION_BY_MAX_ZOOM: readonly {
  maxZoom: number;
  step: number;
}[] = [
  { maxZoom: 11, step: 20 },
  { maxZoom: 13, step: 8 },
  { maxZoom: 15, step: 3 },
  { maxZoom: Number.POSITIVE_INFINITY, step: 1 },
];
